import React, { useEffect, useRef, useState } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { safeJsonParse } from '../../utils/jsonUtils'
import { formatVehicleType, formatRegNumber, getVehicleModel } from '../../utils/vehicleType'
import { ButtonGroup, IconButton, InputAdornment, Modal } from '@mui/material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Typography, List, ListItem, ListItemText } from '@mui/material';
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import ChatIcon from '@mui/icons-material/Chat'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'
import UploadIcon from '@mui/icons-material/Upload';
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem from '@mui/material/MenuItem'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search'
import TablePagination from '@mui/material/TablePagination'
import toast from 'react-hot-toast'
import CloseIcon from '@mui/icons-material/Close'
import axios from '../../api/axios'
import Fab from '@mui/material/Fab'
import SendIcon from '@mui/icons-material/Send'
import { ClockLoader } from 'react-spinners'
import { experimentalStyled as styled } from '@mui/material/styles'
import socket from '../../socket'
import { getDateTimeWithWeekday } from '../../utils/dateUtils'

const columns = [
   { id: 'orderId',            label: 'Order ID',            minWidth: 100 },
   { id: 'createdAt',          label: 'Created',             minWidth: 120 },
   { id: 'updatedAt',          label: 'Updated',             minWidth: 120 },
   { id: 'vehicleInformation', label: 'Vehicle Information', minWidth: 200,
      align: 'center',
      format: (value) => value.toLocaleString('en-US'),
   },
   { id: 'VINnumber',          label: 'Reg Number',          minWidth: 120 },
   { id: 'note',               label: 'Note',                minWidth: 200,
      align: 'center',
      format: (value) => value.toLocaleString('en-US'),
   },
   { id: 'status',             label: 'Request Status',      minWidth: 120,
      align: 'center',
      format: (value) => value.toLocaleString('en-US'),
   },
   { id: 'downloadFiles',      label: 'Download Files',      minWidth: 50,
      align: 'center',
      format: (value) => value.toLocaleString('en-US'),
   },
   { id: 'uploadFiles',        label: 'Upload Files',        minWidth: 50,
      align: 'center',
      format: (value) => value.toLocaleString('en-US'),
   },
   { id: 'support',            label: 'Support',             minWidth: 50,
      align: 'center',
      format: (value) => value.toLocaleString('en-US'),
   },
]
const ServiceStyle1 = {
   position: 'absolute',
   top: '50%',
   left: '50%',
   transform: 'translate(-50%, -50%)',
   width: '500px',
   height: '400px',
   minHeight: '400px',
   maxHeight: '70vh',
   bgcolor: 'background.paper',
   border: '0px',
   borderRadius: 1,
   boxShadow: 24,
   p: 0,
   overflow: 'auto',
}
const ServiceStyle2 = {
   position: 'absolute',
   top: '50%',
   left: '50%',
   transform: 'translate(-50%, -50%)',
   width: '60vw',
   height: '80vh',
   bgcolor: 'background.paper',
   border: '0px',
   borderRadius: 1,
   boxShadow: 24,
   p: 0,
}
const Item = styled(Paper)(({ theme }) => ({
   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
   ...theme.typography.body2,
   padding: '20px 20px 20px 20px',
   height: '70vh',
   display: 'flex',
   flexDirection: 'column',
   gap: '10px',
   textAlign: 'center',
   borderLeft: '5px solid #FA870B',
   color: theme.palette.text.secondary,
}))

export default function Overview() {
   const [account,setAccount] = useState(null);
   const [page, setPage] = React.useState(0)
   const [rowsPerPage, setRowsPerPage] = useState(10)
   const [allData, setAllData] = useState([])
   const [filterSetting, setFilterSetting] = useState('all')

   useEffect(()=>{
      const user = localStorage.getItem('user');
      if(user){
         let parse = safeJsonParse(user);
         setAccount(parse);
      }
   },[]);

   const [downloadList, setDownloadList] = useState({
      origin: [],
      rename: [],
      metadata: {},
   })
   const [open1, setOpen1] = useState(false)
   const [open2, setOpen2] = useState(false)

   /* chatting */
   const [myID, setMyID] = useState('')
   const [name, setName] = useState('')
   const [dataId, setDataId] = useState('')
   const [orderId, setOrderId] = useState('')
   const [VINnumber, setVINnumber] = useState('')
   const [supportID, setSupportID] = useState('')
   const [chattingMsg, setChattingMsg] = useState('')
   const [unreadFileCount, setUnreadFileCount] = useState({})
   const [allMsg, setAllMsg] = useState([])
   const [chatBoxWidth, setChatBoxWidth] = useState(null)
   const [fileData, setFileData] = useState({})
   const [fileOpen, setFileOpen] = useState(false)
   const [isLoading, setIsLoading] = useState(false)
   const inputElement = useRef('fileInput')
   const messagesEndRef = useRef(null)
   const inputRef = useRef(null)
   const [sortConfig, setSortConfig] = useState({ key: 'orderId', direction: 'desc' });
   const [searchTerm, setSearchTerm] = useState('');
   const [openUploadModal, setOpenUploadModal] = useState(false);
   const [uploadTargetRow, setUploadTargetRow] = useState(null);
   const [selectedFiles, setSelectedFiles] = useState([]);

   const handleFileChange = (e) => {
      const files = Array.from(e.target.files);
      setSelectedFiles((prev) => [...prev, ...files]);
   };

   const removeFile = (index) => {
      setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
   };

   const handleOpenUploadModal = (row) => {
      setUploadTargetRow(row);
      setOpenUploadModal(true);
   };

   const handleUploadFiles = async () => {
      if (!selectedFiles || selectedFiles.length === 0) {
         toast.error("No files selected");
         return;
      }

      const formData = new FormData();
      formData.append("id", uploadTargetRow._id);
      formData.append("orderId", uploadTargetRow.orderId);
      formData.append("userId", uploadTargetRow.userId);

      for (let f of selectedFiles) {
         formData.append("files", f);
      }

      try {
         const res = await axios
            .post("addFiles", formData, {
            headers: { "Content-Type": "multipart/form-data" },
         });

         if (res.data.status) {
            socket.emit('request', { to: supportID, name: name })
            toast.success("Files uploaded");
            setOpenUploadModal(false);
            getDataByFilter(account._id);
         } else {
            toast.error(res.data.data);
         }
      } catch (e) {
         toast.error("Upload failed");
      }
   };

   const handleSort = (columnId) => {
      setSortConfig((prevConfig) => {
         if (prevConfig.key === columnId) {
            return {
               key: columnId,
               direction: prevConfig.direction === 'asc' ? 'desc' : 'asc',
            };
         }
         return { key: columnId, direction: 'asc' };
      });
   };

   const filteredData = React.useMemo(() => {
      if (!searchTerm) return allData;
      return allData.filter((row) =>
         columns.some((column) =>
            row[column.id]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
         )
      );
   }, [allData, searchTerm]);

   const sortedData = React.useMemo(() => {
      if (sortConfig.key) {
         return [...filteredData].sort((a, b) => {
            let aVal, bVal;

            if (sortConfig.key === 'support') {
               aVal = unreadFileCount[a._id] ?? 0;
               bVal = unreadFileCount[b._id] ?? 0;
            } else {
               aVal = a[sortConfig.key];
               bVal = b[sortConfig.key];
            }

            const aNum = Number(aVal);
            const bNum = Number(bVal);

            const isNumeric = !isNaN(aNum) && !isNaN(bNum);

            if (isNumeric) {
               return sortConfig.direction === 'asc'
                  ? aNum - bNum
                  : bNum - aNum;
            }

            const aStr = String(aVal).toLowerCase();
            const bStr = String(bVal).toLowerCase();

            if (aStr < bStr) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aStr > bStr) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
         });
      }
      return filteredData;
   }, [filteredData, sortConfig, unreadFileCount]);

   const sendChatting = async () => {
      if (!isLoading) {
         try {
            const date = await getCustomDate()
            let data = {}
            let flag
            setIsLoading(true)
            if (fileData?.name) {
               data = {
                  from: myID + dataId + orderId,
                  to: supportID,
                  msg: '',
                  date: date,
                  status: false,
               }
               flag = true
            } else {
               data = {
                  from: myID + dataId + orderId,
                  to: supportID,
                  msg: chattingMsg,
                  date: date,
                  status: false,
               }
               flag = false
            }
            if (chattingMsg.trim() || fileData?.name) {
               if (fileData?.size / 1000000 > 5) {
                  toast.error(`Can't upload 2MB files`)
                  return
               }

               if (flag) {
                  let params = new FormData()
                  params.append('file', fileData)
                  params.append('data', JSON.stringify(data))
                  params.append('orderId', orderId)
                  params.append('name', name)
                  params.append('VINnumber', VINnumber)
                  await axios
                     .post(
                        `sendToSupportPerFile`,
                        params
                     )
                     .then(async (result) => {
                        if (result.data.status) {
                           data.msg = result.data.data
                           await setAllMsg([...allMsg, data])
                        } else {
                           toast.error(result.data.data)
                        }
                     })
               } else {
                  socket.emit('sendToSupportPerFile', {
                     data,
                     orderId,
                     name,
                     VINnumber,
                  })
                  await setAllMsg([...allMsg, data])
               }
            } else {
               toast.error('Write the message')
            }
            if (flag) {
               setFileData(null)
               setFileOpen(false)
               inputElement.current.value = null
            } else {
               setChattingMsg('')
               inputRef.current.focus()
            }
            setIsLoading(false)
         } catch (error) {
            if (process.env.REACT_APP_MODE) console.log(error)
            toast.error('Ett fel uppstod. Försök igen.')
         }
      } else {
         toast.error('Loading...')
      }
   }

   const getKeyCode = async (e) => {
      if (e.key === 'Enter' && !e.ctrlKey && !e.altKey && !e.shiftKey) {
         await sendChatting()
      }
   }

   const handleChangePage = (event, newPage) => {
      setPage(newPage)
   }

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value)
      setPage(0)
   }

   const getDataByFilter = async (id) => {
      try {
         await axios
            .post(`getDataByFilter`, {
               filter: filterSetting,
               id,
            })
            .then((result) => {
               if (result.data.status) {
                  setUnreadFileCount(result.data.unreadCount)
                  setAllData(result.data.data)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const handleOpen1 = async (origin, rename, metadata) => {
      setDownloadList({
         origin,
         rename,
         metadata,
      })
      setOpen1(true)
   }

   const handleClose1 = () => {
      setOpen1(false)
   }

   const getChattingHistory = async (id) => {
      try {
         await axios
            .post(`getChattingHistory`, {
               id: id,
            })
            .then(async (result) => {
               if (result.data.status) {
                  await setAllMsg(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const handleOpen2 = async (userId, dataId, orderId, VINnumber) => {
      setOpen2(true)
      getChattingHistory(userId + dataId + orderId)
      setMyID(userId)
      setDataId(dataId)
      setOrderId(orderId)
      setVINnumber(VINnumber)
      const data = {
         _id: userId + dataId + orderId,
         to: supportID,
         userId,
         dataId,
         orderId,
         name: `${account?.name}/${orderId}/${formatRegNumber(VINnumber)}`,
         profile: 'file',
      }
      const copy = { ...unreadFileCount }
      copy[dataId] = 0
      setUnreadFileCount(copy)
      socket.emit('addChattingListPerFile', data)
   }

   const handleClose2 = () => {
      setOpen2(false)
   }

   const getSupportID = async () => {
      try {
         await axios
            .post(`getSupportID`)
            .then(async (result) => {
               if (result.data.status) await setSupportID(result.data.data)
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   const getCustomDate = getDateTimeWithWeekday

   const scrollToBottom = () => {
      messagesEndRef.current.scrollIntoView({
         behavior: 'smooth',
         block: 'start',
      })
   }

   const handleFileload = () => {
      inputElement.current.click()
   }

   const getFile = async (e) => {
      setFileData(e.target.files[0])
      setChattingMsg('')
      setFileOpen(true)
   }

   const deleteFile = () => {
      setFileData({})
      setFileOpen(false)
   }

   const getWidth = () =>
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth

   useEffect(() => {
      const setResponsiveness = () => {
         setChatBoxWidth(getWidth() - getWidth() / 2 - 50)
      }
      setResponsiveness()
      window.addEventListener('resize', setResponsiveness)
      return () => window.removeEventListener('resize', setResponsiveness)
   }, [])

   useEffect(() => {
      if (fileData?.name) setFileOpen(true)
      else setFileOpen(false)
   }, [fileData])

   useEffect(() => {
      if (account) {
         setMyID(account?._id)
         setName(account?.name)
         getDataByFilter(account?._id)
         getSupportID()
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [filterSetting, account])

   useEffect(() => {
      socket.on(myID + dataId + orderId, async (e) => {
         await setAllMsg([...allMsg, e.data])
      })
      socket.on('fileReply' + myID, async (e) => {
         const copy = { ...unreadFileCount }
         copy[e.from] += 1
         setUnreadFileCount(copy)
      })
      if (dataId && orderId && myID)
         setTimeout(() => {
            scrollToBottom()
         }, 100)
      return () => {
         socket.off('connect')
         socket.off('disconnect')
         socket.off(myID + dataId + orderId)
         socket.off('fileReply' + myID)
      }
   }, [allMsg, unreadFileCount, dataId, myID, orderId])

   return (
      <Box
         sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: 'rgb(229, 229, 229)',
            overflowY: 'overlay',
         }}
      >
         <Box sx={{ mt: '80px' }}>
            <h3 style={{ margin: '0px' }}>Files Overview</h3>
         </Box>
         <Box
            sx={{
               mt: '10px',
               borderTop: '5px solid #ffc800',
               bgcolor: 'white',
               borderBottomRightRadius: '5px',
               borderBottomLeftRadius: '5px',
               p: '10px',
            }}
         >
            <Grid
               container
               justifyContent={'space-between'}
               spacing={{ xs: 2, md: 3 }}
               columns={{ xs: 4, sm: 8, md: 12 }}
            >
               <Grid item xs={6} sm={6} md={6}>
                  <TextField
                     label="Search and filter"
                     variant="outlined"
                     fullWidth
                     sx={{ mb: 2, width: '300px' }}
                     InputProps={{
                        startAdornment: (
                           <InputAdornment position="start">
                              <SearchIcon />
                           </InputAdornment>
                        ),
                     }}
                     size="small"
                     value={searchTerm}
                     onChange={(e) => setSearchTerm(e.target.value)}
                  />
               </Grid>
               <Grid
                  item
                  xs={3}
                  sm={3}
                  md={3}
                  sx={{ display: 'flex', justifyContent: 'flex-end' }}
               >
                  <FormControl fullWidth>
                     <Select
                        size="small"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={filterSetting}
                        onChange={(e) => setFilterSetting(e.target.value)}
                     >
                        <MenuItem value="all">All Requests</MenuItem>
                        <MenuItem value="completed">Completed Requests</MenuItem>
                        <MenuItem value="in-progress">Pending Requests</MenuItem>
                        <MenuItem value="requested">Submitted Requests</MenuItem>
                        <MenuItem value="cancelled">Cancelled Requests</MenuItem>
                     </Select>
                  </FormControl>
               </Grid>
            </Grid>
            <TableContainer
               sx={{
                  mt: 2,
               }}
            >
               <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                     <TableRow>
                        {columns.map((column) => (
                           <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                 minWidth: column.minWidth,
                                 backgroundColor: '#FA870C',
                                 color: 'white',
                                 cursor: 'pointer',
                              }}
                           onClick={() => handleSort(column.id)}
                           >
                              {column.label}{' '}
                              {sortConfig.key === column.id && (sortConfig.direction === 'asc' ? '▲' : '▼')}
                           </TableCell>
                        ))}
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {sortedData
                        .slice(
                           page * rowsPerPage,
                           page * rowsPerPage + rowsPerPage
                        )
                        .map((row) => {
                           return (
                              <TableRow
                                 hover
                                 role="checkbox"
                                 tabIndex={-1}
                                 key={row._id}
                              >
                                 {columns.map((column) => {
                                    const value = row[column.id]
                                    return (
                                       <TableCell
                                          key={column.id}
                                          align={column.align}
                                       >
                                          {column.id === 'support' ? (
                                             <ButtonGroup
                                                variant="outlined"
                                                aria-label="outlined button group"
                                                onClick={() =>
                                                   handleOpen2(
                                                      row.userId,
                                                      row._id,
                                                      row.orderId,
                                                      row.VINnumber
                                                   )
                                                }
                                             >
                                                <IconButton
                                                   color="primary"
                                                   style={{
                                                      position: 'relative',
                                                   }}
                                                >
                                                   <span
                                                      style={{
                                                         position: 'absolute',
                                                         right: -4,
                                                         top: 6,
                                                         color: 'blue',
                                                         fontWeight: 'bold',
                                                         fontSize: '20px',
                                                      }}
                                                   >
                                                      {unreadFileCount[row._id]}
                                                   </span>{' '}
                                                   <ChatIcon />
                                                </IconButton>
                                             </ButtonGroup>
                                          ) : column.id === 'downloadFiles' ? (
                                             <ButtonGroup
                                                variant="outlined"
                                                aria-label="outlined button group"
                                                onClick={() =>
                                                   handleOpen1(
                                                      row.fileName,
                                                      row.fileRename,
                                                      row.metadata
                                                   )
                                                }
                                             >
                                                <IconButton
                                                   color="primary"
                                                >
                                                   <DownloadForOfflineIcon />
                                                </IconButton>
                                             </ButtonGroup>
                                          ) : column.id === 'uploadFiles' ? (
                                             <ButtonGroup
                                                variant="outlined"
                                                aria-label="outlined button group"
                                                onClick={() => handleOpenUploadModal(row)}
                                             >
                                                <IconButton color="primary">
                                                   <UploadIcon />
                                                </IconButton>
                                             </ButtonGroup>
                                          ) : column.id === 'VINnumber' ? (
                                             row.VINnumber ? formatRegNumber(row.VINnumber) : '-'
                                          ) : column.id === 'vehicleInformation' ? (
                                             <div style={{ lineHeight: '6px' }}>
                                                <p>{formatVehicleType(row.vehicleType)}</p>
                                                <p>{getVehicleModel(row)}</p>
                                                <p>{row.transmission}</p>
                                             </div>
                                          ) : (
                                             value
                                          )}
                                       </TableCell>
                                    )
                                 })}
                              </TableRow>
                           )
                        })}
                  </TableBody>
               </Table>
            </TableContainer>
            <TablePagination
               rowsPerPageOptions={[10, 25, 100]}
               component="div"
               count={allData.length}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Box>
         <Modal
            open={open1}
            onClose={handleClose1}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={ServiceStyle1}>
               <Box
                  sx={{
                     px: 3,
                     py: 1,
                     bgcolor: '#FA870B',
                     borderRadius: 1,
                     color: 'white',
                     display: 'flex',
                     alignItems: 'center',
                  }}
               >
                  <Box>File Overview</Box>
                  <Box sx={{ flex: '1' }}></Box>
                  <Box>
                     <IconButton
                        onClick={() => {
                           handleClose1()
                        }}
                     >
                        <CloseIcon sx={{ color: 'white' }} />
                     </IconButton>
                  </Box>
               </Box>
               <Box sx={{ px: 3 }}>
                  <h3>Click link to download file</h3>
                  {downloadList.metadata?.userIndicies?.length > 0 && (
                     <Box pt={2}>
                        <Box>User Files</Box>
                        <ul>
                           {downloadList.metadata.userIndicies.map((idx) => (
                              <li key={idx} className="file-download-name">
                                 <a
                                    href={`${process.env.REACT_APP_BASE_URL}/fileService/${downloadList?.rename[idx]}`}
                                    download={downloadList?.origin[idx]}
                                 >
                                    {downloadList?.origin[idx]}
                                 </a>
                              </li>
                           ))}
                        </ul>
                     </Box>
                  )}
                  {downloadList.metadata?.supportIndicies?.length > 0 && (
                     <Box pt={2}>
                        <Box>Admin Files</Box>
                        <ul style={{ overflowY: 'auto', height: '100px' }}>
                           {downloadList.metadata.supportIndicies.map((idx) => (
                              <li key={idx} className="file-download-name">
                                    <a
                                       href={`${process.env.REACT_APP_BASE_URL}/fileService/${downloadList.rename[idx]}`}
                                       download={downloadList.origin[idx]}
                                    >
                                       {downloadList.origin[idx]}
                                    </a>
                              </li>
                           ))}
                        </ul>
                     </Box>
                  )}
               </Box>
            </Box>
         </Modal>
         <Modal
            open={open2}
            onClose={handleClose2}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={ServiceStyle2}>
               <Box
                  sx={{
                     px: 3,
                     py: 1,
                     bgcolor: '#FA870B',
                     borderRadius: 1,
                     color: 'white',
                     display: 'flex',
                     alignItems: 'center',
                  }}
               >
                  <Box>Chat Section</Box>
                  <Box sx={{ flex: '1' }}></Box>
                  <Box>
                     <IconButton
                        onClick={() => {
                           handleClose2()
                        }}
                     >
                        <CloseIcon sx={{ color: 'white' }} />
                     </IconButton>
                  </Box>
               </Box>
               <Box sx={{ px: 3 }}>
                  <Item>
                     <Grid
                        container
                        justifyContent="space-between"
                        alignItems="flex-end"
                        paddingX={'2vw'}
                        height={'94%'}
                        fontSize={'16px'}
                        style={{
                           overflowY: 'auto',
                        }}
                     >
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                           {allMsg.map((item, ind) => {
                              const arr = item.msg.split('->')
                              const type = arr[arr.length - 1]
                              return (
                                 <Box
                                    key={ind}
                                    textAlign={
                                       item.from.search(myID) >= 0
                                          ? 'right'
                                          : 'left'
                                    }
                                    color={
                                       item.from.search(myID) >= 0
                                          ? '#FA870B'
                                          : '#e10000'
                                    }
                                    className="chatting-group"
                                    position={'relative'}
                                 >
                                    <Box>
                                       {type === 'file' ? (
                                          <p
                                             className="chatting-msg"
                                             style={{
                                                width: chatBoxWidth,
                                                whiteSpace: 'pre-wrap',
                                             }}
                                          >
                                             <a
                                                style={{
                                                   color: `${
                                                      item.from.search(myID) >=
                                                      0
                                                         ? 'blue'
                                                         : 'green'
                                                   }`,
                                                }}
                                                href={`${
                                                   process.env
                                                      .REACT_APP_BASE_URL
                                                }chatFile/${
                                                   arr[arr.length - 2]
                                                }`}
                                                download={arr[0]}
                                             >
                                                {arr[0]}
                                             </a>
                                          </p>
                                       ) : (
                                          <p
                                             className="chatting-msg"
                                             style={{
                                                width: chatBoxWidth,
                                                whiteSpace: 'pre-wrap',
                                             }}
                                          >
                                             {item.msg}
                                          </p>
                                       )}
                                       {item.from.search(myID) >= 0 ? (
                                          <p className="chatting-right-date">
                                             {item.date}
                                          </p>
                                       ) : (
                                          <p className="chatting-left-date">
                                             {item.date}
                                          </p>
                                       )}
                                    </Box>
                                 </Box>
                              )
                           })}
                           <div ref={messagesEndRef} />
                        </Grid>
                     </Grid>
                     <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'flex-end'}
                     >
                        <Grid item xs={0.5}>
                           <input
                              ref={inputElement}
                              type="file"
                              style={{ display: 'none' }}
                              onChange={(e) => getFile(e)}
                           />
                           <IconButton
                              color="primary"
                              component="label"
                              onClick={handleFileload}
                           >
                              <AttachFileIcon />
                           </IconButton>
                        </Grid>
                        {fileOpen ? (
                           <Grid className="select-file" item xs={10}>
                              <Box className="file-group-box">
                                 <Box className="upload-img-box">
                                    <UploadFileIcon className="upload-img-icon" />
                                 </Box>
                                 <Box className="file-info">
                                    <Box>
                                       <Box className="filename-string">
                                          {fileData?.name}
                                       </Box>
                                       <Box>
                                          {(fileData?.size / 1000000).toFixed(
                                             4
                                          )}{' '}
                                          MB
                                       </Box>
                                    </Box>
                                 </Box>
                              </Box>
                              <Box className="close-img-box">
                                 <HighlightOffIcon
                                    className="close-img-icon"
                                    onClick={() => deleteFile()}
                                 />
                              </Box>
                           </Grid>
                        ) : (
                           <Grid item xs={10}>
                              <TextField
                                 id="filled-multiline-flexible"
                                 ref={inputRef}
                                 label="Type something"
                                 multiline
                                 variant="filled"
                                 minRows={1}
                                 maxRows={3}
                                 fullWidth
                                 value={chattingMsg}
                                 onKeyUp={(e) => getKeyCode(e)}
                                 onChange={(e) =>
                                    setChattingMsg(e.target.value)
                                 }
                              />
                           </Grid>
                        )}
                        <Grid item xs={1}>
                           <Fab
                              color="secondary"
                              aria-label="edit"
                              onClick={() => {
                                 sendChatting()
                              }}
                           >
                              {isLoading ? (
                                 <ClockLoader color="#fff" size={30} />
                              ) : (
                                 <SendIcon />
                              )}
                           </Fab>
                        </Grid>
                     </Grid>
                  </Item>
               </Box>
            </Box>
         </Modal>
         <Dialog open={openUploadModal} onClose={() => setOpenUploadModal(false)}>
         <DialogTitle>Upload files</DialogTitle>
         <DialogContent>
         <input
            accept="*/*"
            style={{ display: 'none' }}
            id="upload-file-input"
            multiple
            type="file"
            onChange={handleFileChange}
         />
         <label htmlFor="upload-file-input">
            <Button
               variant="outlined"
               component="span"
               startIcon={<UploadFileIcon />}
               fullWidth
               sx={{ mb: 2 }}
            >
               Choose files
            </Button>
         </label>
         {selectedFiles.length > 0 ? (
            <Box>
               <Typography variant="subtitle2" gutterBottom>
               Selected files ({selectedFiles.length}):
               </Typography>
               <List dense>
               {selectedFiles.map((file, index) => (
                  <ListItem
                     key={index}
                     secondaryAction={
                     <IconButton edge="end" onClick={() => removeFile(index)}>
                        <DeleteIcon />
                     </IconButton>
                     }
                  >
                     <ListItemText
                     primary={file.name}
                     secondary={`${(file.size / 1024).toFixed(1)} KB`}
                     />
                  </ListItem>
               ))}
               </List>
            </Box>
         ) : (
            <Typography color="text.secondary" variant="body2">
               No files selected yet.
            </Typography>
         )}
         </DialogContent>
         <DialogActions>
            <Button onClick={() => setOpenUploadModal(false)}>Cancel</Button>
            <Button onClick={handleUploadFiles} variant="contained">
               Upload
            </Button>
         </DialogActions>
         </Dialog>
      </Box>
   )
}
